<template>
  <section name="sites">
    <section class="down">
      <header class="header left"><h1>{{ $t('issue') }}</h1></header>
      <heim-dashboard-list>
        <transition-group name="slide-fade" class="list-ctn" tag="section">
          <span v-for="(site, idx) in items" :key="'site-' + idx">
            <heim-site-card class="issue" :site="site" v-if="isSiteDown(site)"></heim-site-card>
          </span>
        </transition-group>
      </heim-dashboard-list>
    </section>
    <section class="up">
      <header class="header left"><h1>{{ $t('noIssue') }}</h1></header>
      <heim-dashboard-list>
        <transition-group name="slide-fade" class="list-ctn" tag="section">
          <span v-for="(site, idx) in items" :key="'site-' + idx">
            <heim-site-card :class="site.errCount > 0 ? 'warn':''" v-if="!isSiteDown(site)" :site="site"></heim-site-card>
          </span>
        </transition-group>
      </heim-dashboard-list>
    </section>
  </section>
</template>

<script>
// @ is an alias to /src
import HeimDashboardList from "@/components/layout/list/heim-dashboard-list";
import HeimSiteCard from "@/components/layout/card/heim-site-card";
import { mapState } from "vuex";
import fuseMixin from "@/mixins/fuse";
export default {
  name: "siteDashboard",
  components: {
    HeimDashboardList,
    HeimSiteCard
  },
  mixins: [fuseMixin],
  mounted() {
    this.$store.dispatch("getSites");
    // we need to setup fuse inside a watcher
    // because otherwise fuse setups itselfs
    // with an empty array (no data has arrived yet)
    this.$watch(
      vm => vm.sites,
      val => {
        this.setupSites();
      }
    );
    this.setupSites();

    this.$store.dispatch("setTitle", "Dashboard - Sites");
  },
  computed: {
    ...mapState(["search"]),
    ...mapState({ sites: state => state.sitesState.sites }),
    ...mapState({ siteLogs: state => state.sitesState.siteLogs }),
    items() {
      const sites = this.filteredSites.filter(site => site.enabled == true);
      for (let idx = 0; idx < sites.length; idx++) {
        const site = sites[idx];
        const logs = this.$store.getters.getSiteLogs(`site-${site.id}`);
        site.logs = [];
        if (typeof logs != "undefined")
          site.logs = logs.slice(
            Math.max(logs.length - (site.nb_occurence + 1), 1)
          );
      }
      return sites;
    }
  },
  methods: {
    isSiteDown(site) {
      site.errCount = 0;
      if (site.logs.length <= 0) return false;
      for (let idx = 0; idx < site.logs.length; idx++) {
        const element = site.logs[idx];
        if (element.status_code >= 400) site.errCount++;
        else site.errCount = 0;
      }
      return site.errCount >= site.nb_occurence ? true : false;
    }
  }
};
</script>

<style scoped>
</style>
